import { useRef } from 'react';

const useOnFocusWithin = ({ onFocus, onBlur }) => {
  const isFocused = useRef(false);

  const handleBlur = (event) => {
    if (!isFocused.current) {
      return;
    }

    const { currentTarget, relatedTarget } = event;
    if (!currentTarget.contains(relatedTarget)) {
      isFocused.current = false;
      onBlur(false);
    }
  };

  const handleFocus = () => {
    if (!isFocused.current) {
      onFocus(true);
      isFocused.current = true;
    }
  };

  return {
    onFocus: handleFocus,
    onBlur: handleBlur
  };
};

export default useOnFocusWithin;
